import type { AnyFunction } from "../lib/event/utils";

/**
 *
 *
 *
 *
 *
 *
 */
export const assignNamespace = <N, K extends keyof N>(
  parent: N,
  key: K,
  implementation: N[K],
  legacy?: Record<string, unknown>,
): N[K] => {
  /*                                                                                        */
  /*                                                             */
  if (import.meta.env.MODE === "test") {
    parent[key] = Object.assign(parent[key] ?? {}, implementation, legacy);
    return parent[key];
  }

  /*                                                      */
  /*                                                                                           */
  const res = Object.assign(parent[key] ?? {}, implementation, legacy);

  /*                                                                   */
  Object.defineProperty(parent, key, {
    configurable: true,
    enumerable: true,

    /*                                                                           */
    get: () => res,

    /*                                                                                                                  */
    set: (value) => {
      if (typeof value !== "object" || value === null) {
        throw new Error(`Cannot assign non-object value to namespace ${String(key)}`);
      }
      Object.assign(res, value);
    },
  });

  return parent[key];
};

export type MemberByPath<T, P extends string> = P extends `${infer K}.${infer Rest}`
  ? K extends keyof T
    ? MemberByPath<T[K], Rest>
    : { error: "Invalid member Path" }
  : P extends keyof T
    ? T[P]
    : { error: "Invalid member Path" };

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const exportSyncFunction = <const P extends string, T>(
  ns: T,
  path: P,
): MemberByPath<T, P> => {
  const parts = (path as string).split(".");
  let current: Record<string, unknown> = ns as never;

  for (const part of parts) {
    if (current[part] === undefined) {
      throw new Error(`Namespace path "${path}" does not exist on the provided namespace.`);
    }
    current = current[part] as never;
  }

  if (typeof current !== "function") {
    throw new Error(`Namespace path "${path}" does not point to a function.`);
  }

  const invoker = (...args: unknown[]): unknown => (current as AnyFunction)(...args);
  return invoker as never;
};
